import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { AuthenticationComponent } from './authentication.component';




const routes: Routes = [
 {path :"authentication",component:AuthenticationComponent ,children:[
   {path:"auth-callback", component:AuthCallbackComponent},
 
 ]}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
